/**
 * TODO
 * THIS IS COPIED FROM SKYSLOPE MACHE AND IDEALLY WE COULD JUST UPDATE
 * TO THE LATEST VERSION OF MACHE BUT THIS CODEBASE IS CURRENTLY WAYYYY
 * BEHIND.
 */
import React from 'react';
import type { Nullable } from '@skyslope/utils';

export type UseStorageApi<T> = [T, React.Dispatch<React.SetStateAction<T>>, () => void];

export function useStorage<T = string>(key: string, getStorage: () => Storage | null): UseStorageApi<T | null>;
export function useStorage<T = string>(
  key: string,
  getStorage: () => Storage | null,
  defaultValue: T | undefined
): UseStorageApi<T | null>;
export function useStorage<T = string>(
  key: string,
  getStorage: () => Storage | null,
  defaultValue: T
): UseStorageApi<T>;
export function useStorage<T = string>(
  key: string,
  getStorage: () => Storage | null,
  defaultValue?: T
): UseStorageApi<T> {
  const [storage] = React.useState(getStorage);
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const getValue = () => (getJsonStorageItem(key, storage) ?? defaultValue) as T;
  const [value, setValue] = React.useState<T>(getValue);

  const valueRef = React.useRef(value);
  valueRef.current = value;

  // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  const updateValue = React.useCallback(() => setValue(getValue()), [key]);

  React.useEffect(() => {
    updateValue();
  }, [updateValue]);

  React.useEffect(() => {
    function eventListener(e: StorageEvent) {
      if (e.key === key) updateValue();
    }
    window.addEventListener('storage', eventListener);
    return () => window.removeEventListener('storage', eventListener);
  }, [key, updateValue]);

  const setter = React.useCallback(
    (newValue: React.SetStateAction<T>) => {
      const valueToStore = newValue instanceof Function ? newValue(valueRef.current) : newValue;
      if (valueToStore == null) {
        storage?.removeItem(key);
      } else {
        setJsonStorageItem(key, valueToStore, storage);
      }
      setValue(valueToStore);
    },
    [key, storage, valueRef]
  );

  return [value, setter, updateValue];
}

function getJsonStorageItem(key: string, storage: Storage | null) {
  if (storage == null) return null;
  const item = storage.getItem(key);
  return item == null || item == '' ? item : safeJsonParse(item);
}

function setJsonStorageItem(key: string, value: any, storage: Storage | null) {
  if (storage == null) return;
  if (value == null) return storage.removeItem(key);
  const strValue = typeof value === 'string' ? value : JSON.stringify(value);
  storage.setItem(key, strValue);
}

function safeJsonParse(input: Nullable<string>) {
  if (input == null) return null;
  try {
    return JSON.parse(input);
  } catch {
    return input;
  }
}
